export const REGEXP = {
  STRONG_PASSWORD:
    /(?=^.{8,24}$)(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%^&*()_\-+}{&;:;'?/&.,<>])(?!.*\s).*$/g, // One lowercase, one uppercase, one digit, one special char, length 8 - 24
  HTML: /<\/?("[^"]*"|'[^']*'|[^>])*(>|$)/gi,
};
